module.exports = __webpack_public_path__ + "static/img/rank_9.3809c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_9.png
// module id = e9JW
// module chunks = 0